import {drawer} from '@cypro/ui/components'
import {PrescribedNameDrawer} from './prescribed-name-drawer'
import {PrescribedNameProvider} from '@/shared/contexts/prescribed-name'
import {PrescribedName} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getPrescribedNameDrawerId(prescribedNameId: string) {
  return `prescribed-name-drawer-${prescribedNameId}`
}

export function openPrescribedNameDrawer(prescribedName: PrescribedName) {
  const id = getPrescribedNameDrawerId(prescribedName.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {prescribedName && (
          <PrescribedNameProvider prescribedName={prescribedName}>
            <PrescribedNameDrawer />
          </PrescribedNameProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'prescribed-name-drawer',
    },
  })
}
